import { render, staticRenderFns } from "./downbtn.vue?vue&type=template&id=adfee56a&scoped=true"
import script from "./downbtn.vue?vue&type=script&lang=js"
export * from "./downbtn.vue?vue&type=script&lang=js"
import style0 from "./downbtn.vue?vue&type=style&index=0&id=adfee56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfee56a",
  null
  
)

export default component.exports